import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { SignatureService } from 'src/app/data/signature.service';
import { StartSignatureRequest, SignatureFileType } from 'src/app/contracts/requests/start-signature-request';

export interface SignatureOptions {
  fileIds: number[];
  fileType: SignatureFileType;
  onError?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SignatureHandlerService {
  private spinner = inject(NgxSpinnerService);
  private signatureService = inject(SignatureService);

  async startSigningProcess(options: SignatureOptions): Promise<void> {
    this.spinner.show();
    
    try {
      const request: StartSignatureRequest = {
        FileIds: options.fileIds,
        FileType: options.fileType
      };

      const response = await firstValueFrom(this.signatureService.startSignature(request));

      if (response && response.AuthorizationUrl) {
        window.location.href = response.AuthorizationUrl;
      } else {
        this.spinner.hide();
        options.onError?.();
      }
    } catch (error) {
      console.error('Error starting signature process:', error);
      this.spinner.hide();
      options.onError?.();
    }
  }
}
